import { cn } from '@/lib/utils';
import * as React from 'react';
import styles from './Textarea.module.css';

export interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ className, onChange, ...props }, ref) => {
    const internalRef = React.useRef<HTMLTextAreaElement | null>(null);
    const combinedRef = (node: HTMLTextAreaElement) => {
      internalRef.current = node;
      if (typeof ref === 'function') ref(node);
      else if (ref) (ref as React.MutableRefObject<HTMLTextAreaElement | null>).current = node;
    };

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      const textarea = internalRef.current;
      if (textarea) {
        textarea.style.height = 'auto';
        textarea.style.height = `${textarea.scrollHeight}px`;
      }
      onChange?.(e);
    };

    React.useEffect(() => {
      const textarea = internalRef.current;
      if (textarea) {
        textarea.style.height = 'auto';
        textarea.style.height = `${Math.max(textarea.scrollHeight, 64)}px`;
      }
    }, [props.value]);

    return (
      <textarea
        className={cn(styles.input, className)}
        ref={combinedRef}
        {...props}
        onChange={handleChange}
        style={{ overflow: 'hidden', resize: 'none', ...props.style }}
      />
    );
  }
);
Textarea.displayName = 'Textarea';

export default Textarea;
